import axios from "axios";
import { getToken, getTokenMicro } from "../../config/getToken";
import { env } from "../../env";
import { convertFileToBase64Dynamic } from "../../utils/functions";

//TODO: ajustar el objeto data con los nuevos atributos donde se haga el llamado a GetAlarms, el axios ya está ajustado
/** Obtiene el listado de alarmas cargadas de una compañía.
 * @param {Object} data - Datos de consulta.
 * @returns {Promise<*>} Listado de alarmas. */
export async function GetAlarms(data) {
  const token = await getToken();
  const tokenMicro = await getTokenMicro();

  return axios({
    method: "POST",
    data: data,
    url: `masters/uploads/companies`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
      "X-Authorization": tokenMicro,
    },
  });
}

/** Obtiene la guía de alarmas.
 * @param {string} type - Tipo de guía: "web" para modales de crear/editar, "file" para carga de archivos.
 * @returns {Promise<*>} Guía codificada. */
export async function GetAlarmsGuide(type = "file") {
  const token = await getToken();
  const route = type === "web" ? "downloads/guides/web" : "downloads/guides/file";
  return axios({
    method: "GET",
    url: `alarms/${route}`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Obtiene la plantilla de alarmas.
 * @returns {Promise<*>} Plantilla codificada. */
export async function GetAlarmsTemplate() {
  const token = await getToken();
  return axios({
    method: "GET",
    url: `alarms/downloads/templates`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Descarga un archivo de alarma.
 * @param {Object} data - Datos de descarga.
 * @returns {Promise<*>} Archivo descargado. */
export async function DownloadAlarmFile(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    url: `masters/downloads`,
    baseURL: env.REACT_APP_API_URL,
    data: data,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Descarga el log de errores de alarma.
 * @param {Object} data - Datos del log a descargar.
 * @returns {Promise<*>} Log de errores. */
export async function DownloadAlarmErrorLog(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    url: `masters/downloads/logs`,
    baseURL: env.REACT_APP_API_URL,
    data: data,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Obtiene la vista previa de una alarma.
 * @param {Object} data - Datos de consulta.
 * @returns {Promise<*>} Vista previa de la alarma. */
export async function GetPreviewAlarm(data) {
  const { eanCompany } = data;
  const token = await getToken();
  return axios({
    method: "GET",
    url: `products/companies/${eanCompany}`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    data: data,
    headers: {
      Authorization: token,
    },
  });
}

//TODO: Ajustar el objeto GenerateDownloadAlarmRequest por integración de grupo empresarial
/** Genera una solicitud de descarga de alarma.
 * @param {Object} data - Datos de la solicitud.
 * @returns {Promise<*>} Respuesta de la solicitud. */
export async function GenerateDownloadAlarmRequest(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    timeout: 1000 * 90,
    url: `alarms/downloads`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    data: data,
    headers: {
      Authorization: token,
    },
  });
}

/** Lista las alarmas descargadas de una compañía.
 * @param {Object} data - Datos de consulta.
 * @returns {Promise<*>} Listado de descargas. */
export async function ListDownloadAlarm(data) {
  const token = await getToken();
  const tokenMicro = await getTokenMicro();

  return axios({
    method: "POST",
    data: data,
    url: `masters/downloads/companies`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
      "X-Authorization": tokenMicro,
    },
  });
}

/**
 * Función que permite utilizar el servicio de subir el archivo externo al sistema
 * @param data Archivo a subir
 */
export async function UploadAlarmFile(data) {
  const token = await getToken();
  const formData = new FormData();

  formData.append("file", data.fileUpload);

  const tokenMicro = await getTokenMicro();

  const finalData = await convertFileToBase64Dynamic(formData, data);
  return axios({
    method: "POST",
    url: "alarms/uploads",
    data: finalData,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
      "X-Authorization": tokenMicro,
    },
  });
}

/** Descarga un archivo de alarma desde la sección de descargas.
 * @param {Object} data - Datos de descarga.
 * @returns {Promise<*>} Archivo descargado. */
export async function DownloadAlarmOnDownload(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    url: `masters/downloads`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    data: data,
    headers: {
      Authorization: token,
    },
  });
}